/* eslint-disable no-unused-vars */
import React, { useEffect, Suspense, lazy } from "react";
import "./App.css";
import { initGA, logPageView } from "./Utils/Analytics";
import { Route, Routes, useLocation } from "react-router-dom";
import { Bookings } from "./Page/BookingPage/Booking";
import PujaDetailPage from "./Page/PujaDetailPage/PujaDetailPage";
import EachBooking from "./Page/BookingDetailPage/BookingDetail";
import TermsAndConditions from "./Page/TermsAndConditions/TermsAndConditions";
import Contact from "./Page/ContactUs/Contact";
const About = lazy(() => import("./Page/AboutUs/AboutUs"));
const WhoIsPooja = lazy(() => import("./Page/WhoIsPooja/WhoIsPooja"));
const Refund = lazy(() => import("./Page/Refund/Refund"));
const Privacy = lazy(() => import("./Page/PrivacyPolicy/PrivacyPolicy"));
const Menu = lazy(() => import("./Component/Menu/Menu"));
const Profile = lazy(() => import("./Page/MyProfile/MyProfile"));
const MyBooking = lazy(() => import("./Page/MyBooking/MyBooking"));
const Thankyou = lazy(() => import("./Page/Thankyou/Thankyou"));
const DharmaPage = lazy(() => import("./Page/Dharma/index.jsx"));
const HomePage = lazy(() => import("./Page/HomePage/index.jsx"));
const OfferingsPage = lazy(() => import("./Page/OfferingsPage/index.jsx"));

import Loader from "./Component/Loader/Loader";

function App() {
  const location = useLocation();

  useEffect(() => {
    // PERFORMANCE: Only initialize analytics on first mount
    initGA();
    logPageView();
    window.addEventListener("popstate", logPageView);
    return () => window.removeEventListener("popstate", logPageView);
  }, []);

  useEffect(() => {
    // PERFORMANCE: Use 'auto' for instant scroll without layout thrash
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [location.pathname]);

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/css/main.7ca95c27.css";
    link.media = "print";
    link.onload = () => {
      link.media = "all";
    };
    document.head.appendChild(link);
    return () => document.head.removeChild(link);
  }, []);

  return (
    <div>
      <Suspense
        fallback={
          <div
            style={{
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loader fullScreen />
          </div>
        }
      >
        <Routes>
          {/* <Route exact path="/library" element={ <Libary />} /> */}
          <Route exact path="/offerings" element={<OfferingsPage />} />
          <Route
            exact
            path="/refund-cancellation-policy"
            element={<Refund />}
          />
          <Route exact path="/privacy-policy" element={<Privacy />} />
          <Route
            exact
            path="/terms-conditions"
            element={<TermsAndConditions />}
          />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/" element={<HomePage />} />
          <Route
            exact
            path="/poojas/telugu/:pujaName"
            element={<PujaDetailPage />}
          />
          <Route exact path="/pujaris" element={<WhoIsPooja />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/menu" element={<Menu />} />
          <Route exact path="/profile" element={<Profile />} />
          <Route exact path="/mybookings" element={<MyBooking />} />
          <Route exact path="/booking-success" element={<Thankyou />} />
          <Route exact path="/mydharma" element={<DharmaPage />} />
          <Route
            exact
            path="/my-bookings/:bookingNumber"
            element={<EachBooking />}
          />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
